<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>

          <CCardBody>
            <BTabs :active-tab.sync="active_tab" >
              <BTab v-if="has_permission('ProductCoding') && get_access('inventory_coding')" :title="$t('productCoding')">
                <ProductCoding/>
              </BTab>
              <BTab v-if="has_permission('ProductNature') && get_access('main_group')" :title="$t('mainGroup')">
                <ProductNatures/>
              </BTab>

              <BTab v-if="has_permission('Categories')" :title="$t('productGroup')">
                <Categories/>
              </BTab>
              <BTab v-if="has_permission('BrandInfo')" :title="$t('router.brands')">
                <Brands/>
              </BTab>
              <BTab v-if="has_permission('AddUnit')" :title="$t('components.productUnit')">
                <ProductUnits/>
              </BTab>
              <BTab v-if="has_permission('Warehouses')" :title="$t('router.warehouse')">
                <Places/>
              </BTab>
              <BTab v-if="has_permission('DeliveryCosts')" :title="$t('deliveryCosts')">
                <DeliveryCosts/>
              </BTab>
              <BTab v-if="get_access('customer_type')" title="نوع مشتری">
                <CustomerTypes/>
              </BTab>


              <BTab v-if="get_access('hyper_sale')" title="ترازو">
                <tarazo/>
              </BTab>


            </BTabs>


          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import BTabs from "../../tabs/BTabs";
import ProductCoding from "@/views/panel/settings/ProductCoding";
var items = [];
import tarazo from "../base/tarazo.vue";
import Categories from "../base/Categories";
import ProductUnits from "../base/ProductUnits";
import Brands from "../base/Brands";
import Places from "../base/Places";
import ProductNatures from "../base/ProductNatures";
import DeliveryCosts from "./DeliveryCosts";
import CustomerTypes from "../base/CustomerTypes";
import BTab from "../../tabs/BTab";
export default {
  name: 'SaleSettingsComponent',
  components: {
    BTab,
    BTabs,
    Categories,
    ProductUnits,
    Brands,
    Places,
    ProductNatures,
    ProductCoding,
    DeliveryCosts,
    CustomerTypes,
    tarazo
  },
  data() {
    return {
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,

      active_tab:parseInt(localStorage.getItem("inventory_setting_active_tab",0)),

    }
  }, mounted() {
    this.$root.root_validate_errors = [];

    this.get_lists();

  }, watch: {

    'active_tab': function () {
      localStorage.setItem("inventory_setting_active_tab",this.active_tab)
    }
  },
  methods: {

  }
}

</script>
